import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IFocusInput {
  isFocused: boolean
}

const initialState: IFocusInput = {
  isFocused: false,
}

const formModeSlice = createSlice({
  name: 'isFocused',
  initialState,
  reducers: {
    setIsFocused(state, action: PayloadAction<boolean>) {
      state.isFocused = action.payload
    },
  },
})

export const { setIsFocused } = formModeSlice.actions
export default formModeSlice.reducer
